import { getData, postData, convertPageModel } from './api-base.service';

export const saveCaptureImage = (videoAppointmentId,fileStorageId, isFailure, message) => {
  let data = {
    VideoAppointmentId: videoAppointmentId,
    FileStorageId: fileStorageId, 
    IsFailure: isFailure, 
    Message: message};
  let result = postData(`/CaptureImage/SaveCaptureImage`, data);
  return result;
}



// WEBPACK FOOTER //
// ./src/service/captureImage.service.js